import {
    AfterViewInit,
    Directive,
    ElementRef,
    Input,
    OnChanges,
} from '@angular/core';
import { FeatureDetectionService } from '../helpers/feature-detection.service';

@Directive({
    selector: '[appScrollToElement]',
})
export class ScrollToElementDirective implements AfterViewInit, OnChanges {
    private initialized = false;

    @Input('appScrollToElement') active? = true;

    constructor(
        private elementRef: ElementRef<HTMLElement>,
        private featureDetectionService: FeatureDetectionService
    ) {}

    ngAfterViewInit() {
        this.initialized = true;
        this.scrollToElement();
    }

    ngOnChanges() {
        this.scrollToElement();
    }

    private scrollToElement(): void {
        if (!this.active) return;
        if (!this.featureDetectionService.isBrowser) return;
        if (!this.initialized) return;

        requestAnimationFrame(() =>
            this.elementRef.nativeElement.scrollIntoView({
                behavior: 'smooth',
            })
        );
    }
}
